import { GenericFilter } from '@/components/GenericFilter';
import type { ListMaterialFilterType, ListMaterialFilterTypeWithValues } from '@shelflix/schemas/material/list';

export function MaterialListFilter({ onChange }: { onChange: (filters: ListMaterialFilterTypeWithValues) => void }) {
  const options: ListMaterialFilterType = {
    search: {
      label: 'Identificador material',
      fields: ['code'],
    },
    filter: [
      {
        label: 'Status',
        field: {
          condition: 'equals',
          name: 'status',
        },
        items: [
          {
            text: 'Ativo',
            value: 'ACTIVE',
          },
          {
            text: 'Alerta',
            value: 'WARN',
          },
          {
            text: 'Offline',
            value: 'OFFLINE',
          },
          {
            text: 'Manutenção',
            value: 'MAINTENANCE',
          },
          {
            text: 'Descartado',
            value: 'DISCARDED',
          },
        ],
      },
    ],
  };

  return <GenericFilter options={options} onChange={onChange} />;
}
